// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/button/button.scss
// module id = 517
// module chunks = 0